export default __webpack_public_path__ + "presonus-studio-one.3a89f98a.png";